import { RouteComponentProps } from 'react-router-dom';
import { EnrollmentFormPage } from './features/Experience/pages/EnrollmentForms';
import { StandaloneAppPageExperienceOverview } from './features/Experience/pages/Overview';
import { SsoTestPage } from './features/Experience/pages/SsoTest';
import { StandaloneAppPageTaskDetails } from './features/Experience/pages/TaskDetails';
import { StandaloneAppPageMoment } from './features/Moment/pages';
import { ROUTES, ROUTES_V2 } from './routes';
import { EmployeeAppPageDashboard } from './v2/featutres/Experience/pages/Dashboard';
import {
  EmployeeAppPageInbox,
  EmployeeAppPageInboxMessage,
  EmployeeAppPageInboxMessages,
  EmployeeAppPageInboxMoment,
  EmployeeAppPageInboxTask,
  EmployeeAppPageInboxTasks
} from './v2/featutres/Experience/pages/Inbox';
import { EmployeeAppPageExperienceInstance } from './v2/featutres/Experience/pages/Instance';
import { EmployeeAppPageExperienceMessageDetails } from './v2/featutres/Experience/pages/MessageDetails';
import { EmployeeAppPageExperienceTaskDetails } from './v2/featutres/Experience/pages/TaskDetails';

export interface IPage<T = any> {
  path: string;
  redirectFrom?: string[];
  render: (props: RouteComponentProps<T>, v: number) => JSX.Element;
  trackingName: string;
}

export const PAGES: IPage[] = [
  {
    path: ROUTES.overview.path,
    render: (p: RouteComponentProps<{ accessToken: string }>, v) => (
      <StandaloneAppPageExperienceOverview
        accessToken={p.match.params.accessToken}
        v={v}
      />
    ),
    trackingName: 'Employee App: Experience Page'
  },
  {
    path: ROUTES.taskDetails.path,
    render: (
      p: RouteComponentProps<{ accessToken: string; taskId: string }>,
      v
    ) => (
      <StandaloneAppPageTaskDetails
        accessToken={p.match.params.accessToken}
        taskId={p.match.params.taskId}
        v={v}
      />
    ),
    trackingName: 'Employee App: Task Details Page'
  },
  {
    path: ROUTES.subTaskDetails.path,
    render: (
      p: RouteComponentProps<{
        accessToken: string;
        taskId: string;
        subTaskId: string;
      }>,
      v
    ) => (
      <StandaloneAppPageTaskDetails
        accessToken={p.match.params.accessToken}
        taskId={p.match.params.taskId}
        subTaskId={p.match.params.subTaskId}
        v={v}
        /* TODO consume passed in action */
      />
    ),
    trackingName: 'Employee App: Sub-Task Details Page'
  },

  {
    path: ROUTES.legacy.overview.path,
    render: (p: RouteComponentProps<{ accessToken: string }>, v) => (
      <StandaloneAppPageExperienceOverview
        accessToken={p.match.params.accessToken}
        v={v}
      />
    ),
    trackingName: 'Employee App: Experience Page'
  },
  {
    path: ROUTES.legacy.taskDetails.path,
    render: (
      p: RouteComponentProps<{ accessToken: string; taskId: string }>,
      v
    ) => (
      <StandaloneAppPageTaskDetails
        accessToken={p.match.params.accessToken}
        taskId={p.match.params.taskId}
        v={v}
      />
    ),
    trackingName: 'Employee App: Task Details Page'
  },
  {
    path: ROUTES.legacy.subTaskDetails.path,
    render: (
      p: RouteComponentProps<{
        accessToken: string;
        taskId: string;
        subTaskId: string;
      }>,
      v
    ) => (
      <StandaloneAppPageTaskDetails
        accessToken={p.match.params.accessToken}
        taskId={p.match.params.taskId}
        subTaskId={p.match.params.subTaskId}
        v={v}
        /* TODO consume passed in action */
      />
    ),
    trackingName: 'Employee App: Sub-Task Details Page'
  },
  {
    path: ROUTES.legacy.momentDetails.path,
    render: (p: RouteComponentProps<{ accessToken: string }>, v) => (
      <StandaloneAppPageMoment accessToken={p.match.params.accessToken} v={v} />
    ),
    trackingName: 'Employee App: Moment Page'
  },
  {
    path: '/sso-test/:accessToken',
    render: (p: RouteComponentProps<{ accessToken: string }>, v) => (
      <SsoTestPage accessToken={p.match.params.accessToken} />
    ),

    trackingName: 'Employee App: SSO Test'
  },
  {
    path: ROUTES.enrollmentForms.path,
    render: (p: RouteComponentProps<{ accessToken: string }>, v) => (
      <EnrollmentFormPage accessToken={p.match.params.accessToken} />
    ),
    trackingName: 'Employee App: Experience Page'
  },
  {
    path: ROUTES.momentDetails.path,
    render: (p: RouteComponentProps<{ accessToken: string }>, v) => (
      <StandaloneAppPageMoment accessToken={p.match.params.accessToken} v={v} />
    ),
    trackingName: 'Employee App: Moment Page'
  },
  {
    path: ROUTES_V2.instance.path,
    render: (
      p: RouteComponentProps<{
        // actorAccessToken: string;
        instanceAccessToken: string;
      }>,
      v
    ) => (
      <EmployeeAppPageExperienceInstance
        actorAccessToken={/* p.match.params.actorAccessToken */ ''}
        instanceAccessToken={p.match.params.instanceAccessToken}
        v={v}
      />
    ),
    trackingName: 'Employee App: Instance Page'
  },
  {
    path: ROUTES_V2.taskDetails.path,
    render: (
      p: RouteComponentProps<{
        // actorAccessToken: string;
        instanceAccessToken: string;
        taskId: string;
      }>,
      v
    ) => (
      <EmployeeAppPageExperienceTaskDetails
        actorAccessToken={/* p.match.params.actorAccessToken */ ''}
        instanceAccessToken={p.match.params.instanceAccessToken}
        taskId={p.match.params.taskId}
        v={v}
      />
    ),
    trackingName: 'Employee App: Single Task'
  },
  {
    path: ROUTES_V2.subTaskDetails.path,
    render: (
      p: RouteComponentProps<{
        instanceAccessToken: string;
        taskId: string;
        subTaskId: string;
      }>,
      v
    ) => (
      <EmployeeAppPageExperienceTaskDetails
        actorAccessToken={/* p.match.params.actorAccessToken */ ''}
        instanceAccessToken={p.match.params.instanceAccessToken}
        taskId={p.match.params.taskId}
        v={v}
      />
    ),
    trackingName: 'Employee App: Single Task (via sub-task link)'
  },
  {
    path: ROUTES_V2.messageDetails.path,
    render: (
      p: RouteComponentProps<{
        // actorAccessToken: string;
        instanceAccessToken: string;
        messageId: string;
      }>,
      v
    ) => (
      <EmployeeAppPageExperienceMessageDetails
        actorAccessToken={/* p.match.params.actorAccessToken */ ''}
        instanceAccessToken={p.match.params.instanceAccessToken}
        messageId={p.match.params.messageId}
        v={v}
      />
    ),
    trackingName: 'Employee App: Single Message'
  },
  {
    path: ROUTES_V2.inbox.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
      }>,
      v
    ) => (
      <EmployeeAppPageInbox
        userAccessToken={p.match.params.userAccessToken}
        v={v}
      />
    ),

    trackingName: 'Employee App: Combined Inbox'
  },

  {
    path: ROUTES_V2.inboxTasks.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
        taskTemplateId: string;
      }>,
      v
    ) => (
      <EmployeeAppPageInboxTasks
        userAccessToken={p.match.params.userAccessToken}
        taskTemplateId={p.match.params.taskTemplateId}
        v={v}
      />
    ),

    trackingName: 'Employee App: Task in Batch'
  },

  {
    path: ROUTES_V2.inboxTask.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
        taskTemplateId: string;
        instanceAccessToken: string;
      }>,
      v
    ) => (
      <EmployeeAppPageInboxTask
        userAccessToken={p.match.params.userAccessToken}
        taskTemplateId={p.match.params.taskTemplateId}
        instanceAccessToken={p.match.params.instanceAccessToken}
        v={v}
      />
    ),

    trackingName: 'Employee App: Single Task'
  },

  {
    path: ROUTES_V2.inboxMessages.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
        msgTemplateId: string;
      }>,
      v
    ) => (
      <EmployeeAppPageInboxMessages
        userAccessToken={p.match.params.userAccessToken}
        msgTemplateId={p.match.params.msgTemplateId}
        v={v}
      />
    ),

    trackingName: 'Employee App: Message in Batch'
  },

  {
    path: ROUTES_V2.inboxMessage.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
        msgTemplateId: string;
        instanceAccessToken: string;
      }>,
      v
    ) => (
      <EmployeeAppPageInboxMessage
        userAccessToken={p.match.params.userAccessToken}
        msgTemplateId={p.match.params.msgTemplateId}
        instanceAccessToken={p.match.params.instanceAccessToken}
        v={v}
      />
    ),

    trackingName: 'Employee App: Single Message'
  },
  {
    path: ROUTES_V2.dashboard.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
      }>,
      v
    ) => (
      <EmployeeAppPageDashboard
        userAccessToken={p.match.params.userAccessToken}
        v={v}
      />
    ),
    trackingName: 'Employee App: Dashboard'
  },
  {
    path: ROUTES_V2.inboxMoment.path,
    render: (
      p: RouteComponentProps<{
        userAccessToken: string;
        momentInstanceAccessToken: string;
      }>,
      v
    ) => (
      <EmployeeAppPageInboxMoment
        userAccessToken={p.match.params.userAccessToken}
        momentInstanceAccessToken={p.match.params.momentInstanceAccessToken}
        v={v}
      />
    ),
    trackingName: 'Employee App: Moment Inbox Page'
  }
];
